import React from 'react'
import "react-pro-sidebar/dist/css/styles.css";
import {
  ProSidebar,
  SidebarHeader,
  SidebarFooter,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import {useDispatch } from 'react-redux';
import YIcon from '../../assets/svgs/YIcon.svg'


const MobileMenuContent = ({toogleSidebar}) => {
  return (
    <ProSidebar>
      <SidebarHeader>
        <div className="sidebar-header">
          <a href="https://www.yolocoliving.com.br/" target='' className="sidebar-header-inner">
            <img style={{width:'40px',height:'45px'}}
              className="nav_logo_img img-fluid mt20"
              src={YIcon}
              alt="header-logo.png"
            />
          </a>
          {/* End .logo */}

          <div
            className="fix-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={()=>toogleSidebar()}
          >
            <span className="flaticon-close"></span>
          </div>
          {/* Mobile Menu close icon */}
        </div>

        {/* End logo */}
      </SidebarHeader>

      <SidebarContent>        
        <Menu>
        <MenuItem>
            <a href='/'
              className="ui-active"
              onClick={()=>toogleSidebar()}
            >
              Início
            </a>
          </MenuItem>
          <MenuItem >
            <a
              href='/#comofunciona'
              className="ui-active"
              onClick={()=>toogleSidebar()}
            >
              Como funciona
            </a>
          </MenuItem>
          <MenuItem >
            <a
              href='/#beneficios'
              className="ui-active"
              onClick={()=>toogleSidebar()}
            >
              Benefícios
            </a>
          </MenuItem>
          
          {/* <MenuItem >
            <a
            href='/create-property-page-1'
            onClick={navigateCreateProperty}
            >
              Cadastrar meu imóvel
            </a>
          </MenuItem> */}
                    
        </Menu>
      </SidebarContent>
    </ProSidebar>
  );
}

export default MobileMenuContent;
